module.exports = __webpack_public_path__ + "static/img/pic5.2745eac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case2/pic5.jpg
// module id = cPOq
// module chunks = 1